import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Minus, LogIn } from 'lucide-react';

export const LoginGate = ({ site, onLogin }) => {
  const { t } = useTranslation();
  const [minimized, setMinimized] = useState(false);

  if (minimized) {
    return (
      <button
        data-testid="login-gate-expand"
        onClick={() => setMinimized(false)}
        className="glass-panel rounded-full pl-4 pr-5 py-2.5 flex items-center gap-2 shadow-lg hover:-translate-y-0.5 transition"
      >
        <LogIn className="w-4 h-4 text-brand" />
        <span className="text-sm font-medium text-brand-ink">{t('hero.expand')}</span>
      </button>
    );
  }

  return (
    <div className="glass-panel rounded-3xl p-4 sm:p-7 relative" data-testid="login-gate">
      <button
        data-testid="login-gate-minimize"
        onClick={() => setMinimized(true)}
        title={t('hero.minimize')}
        className="absolute top-2.5 right-2.5 w-7 h-7 rounded-full hover:bg-black/10 flex items-center justify-center"
      >
        <Minus className="w-4 h-4 text-brand-dim" />
      </button>
      <h1 className="font-display font-black text-[4.2vw] sm:text-4xl tracking-tight text-brand-ink leading-tight sm:leading-[1.05] mb-1.5 sm:mb-2 whitespace-nowrap sm:whitespace-normal pr-6 sm:pr-0">
        {site.hero_title || t('hero.title')}
      </h1>
      <p className="text-brand-slate text-xs sm:text-base mb-3 sm:mb-5">
        {site.hero_subtitle || t('hero.subtitle')}
      </p>
      <Button
        data-testid="login-gate-btn"
        onClick={onLogin}
        className="rounded-full bg-brand hover:bg-brand-hover text-white px-4 py-3 sm:px-6 sm:py-5 text-sm sm:text-base shadow-lg"
      >
        {site.cta_text || t('hero.cta')}
      </Button>
    </div>
  );
};

export default LoginGate;
